import { Button } from '@mui/material';
import { IconFilter, IconRepeat, IconMapPin, IconBuildingHospital } from '@tabler/icons-react';
import PDFGeneratorButton from './PDF/PDFGeneratorButton';
import { useCIHAFiltersContext } from './Filters/hooks/useCIHAFiltersContext';

export const Buttons = ({ onClickFilters, onClickCityFilter, onClickCidadeFilter }) => {
    const { resetFilters, filters, isAdm } = useCIHAFiltersContext();

    return (
        <div className="d-flex" style={{ gap: '8px' }}>
            <Button
                onClick={onClickFilters}
                variant="outlined"
                startIcon={<IconFilter size={20} />}
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                Filtros
            </Button>
            {isAdm && (
                <Button
                    onClick={onClickCidadeFilter}
                    variant="outlined"
                    startIcon={<IconMapPin size={20} />}
                    style={{
                        height: '40px',
                        borderRadius: '8px',
                        borderColor: '#E9EAEB',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '14px',
                        padding: '0 16px',
                        color: '#252B37'
                    }}
                    sx={{
                        '&:hover': {
                            backgroundColor: '#fff',
                            borderColor: '#E9EAEB',
                            boxShadow: 'none'
                        }
                    }}
                >
                    {filters.cidade?.label}
                </Button>
            )}
            <Button
                onClick={onClickCityFilter}
                variant="outlined"
                startIcon={<IconBuildingHospital size={20} />}
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                {filters.unidade?.label}
            </Button>
            <Button
                onClick={resetFilters}
                variant="outlined"
                style={{
                    height: '40px',
                    borderRadius: '8px',
                    borderColor: '#E9EAEB',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '14px',
                    padding: '0 16px',
                    color: '#252B37'
                }}
                sx={{
                    '&:hover': {
                        backgroundColor: '#fff',
                        borderColor: '#E9EAEB',
                        boxShadow: 'none'
                    }
                }}
            >
                <IconRepeat size={20} />
            </Button>

            <PDFGeneratorButton className={'pdf-button-dashboards'} />
        </div>
    );
};
